import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { RootState } from "features/config/store";
import { DailyInventoryTableData } from "features/ms6/core/domain/DailyInventoryTableData.model";
import {
  DailyInventoryTableDataResponse,
  DailyInventoryTableDataRepository,
} from "features/ms6/data/ms6.repository";

export enum dailyInventoryTableDataState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: dailyInventoryTableDataState;
  message: string;
  data: DailyInventoryTableData | undefined;
}

const initialState: InitialState = {
  status: dailyInventoryTableDataState.initial,
  message: "",
  data: undefined,
};

export const dailyInventoryTableData = createAsyncThunk(
  "dailyInventoryTableData",
  async (_, { rejectWithValue }) => {
    try {
      const response: DailyInventoryTableDataResponse =
        await DailyInventoryTableDataRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const dailyInventoryTableDataSlice = createSlice({
  name: "dailyInventoryTableData",
  initialState,
  reducers: {
    resetdailyInventoryTableData: (state) => {
      state.status = dailyInventoryTableDataState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dailyInventoryTableData.pending, (state) => {
        state.status = dailyInventoryTableDataState.inProgress;
      })
      .addCase(dailyInventoryTableData.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = dailyInventoryTableDataState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(dailyInventoryTableData.rejected, (state, action) => {
        state.status = dailyInventoryTableDataState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectdailyInventoryTableData = (state: RootState) =>
  state.dailyInventoryTableData;
export const { resetdailyInventoryTableData } =
  dailyInventoryTableDataSlice.actions;
export default dailyInventoryTableDataSlice.reducer;
